/* pd-compare-series — 系列比较 carousel + variant 选 + CTA 加购
   原 sections/pd-compare-series.liquid 的 inline IIFE 抽出，封装为 custom
   element。每个 <pd-compare-series> 实例独立 carousel state 和 variant 行为。 */
(function () {
  'use strict';
  if (window.customElements.get('pd-compare-series')) return;

  // GA4 add_to_cart 上报：CTA 加购走自定义 fetch，绕过 ga4-script.liquid 的 click 监听，
  // 这里直推 dataLayer 兜底。reset → push 双步模拟 GA4Initializer.push。
  // 加购成功后立即跳 /cart：先同步 push（dataLayer 是同步队列），GTM 在跳转期间用 beacon 兜底发送。
  function pdCsPushAddToCartGA4(items, moduleName) {
    if (!items || !items.length) return;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var ga4Items = items.map(function (it, idx) {
      var unit = it && (it.final_price != null ? it.final_price : it.price);
      var price = typeof unit === 'number' ? unit / 100 : 0;
      var qty = Number(it && it.quantity) || 1;
      return {
        item_id: (it && (it.product_id || it.id)) || '',
        item_name: (it && (it.product_title || it.title)) || '',
        item_variant: (it && it.variant_title) || '',
        item_brand: 'Speediance',
        item_category: 'product',
        price: price,
        quantity: qty,
        index: idx
      };
    });
    var value = ga4Items.reduce(function (s, it) {
      return s + (Number(it.price) || 0) * (Number(it.quantity) || 1);
    }, 0);
    var payload = {
      event: 'ga4Event',
      event_name: 'add_to_cart',
      event_parameters: {
        currency: currency,
        module_name: moduleName || 'pd_compare_series',
        value: value,
        items: ga4Items
      }
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push(payload);
  }

  class PdCompareSeries extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      this.cards = this.querySelector('[data-pd-cs-cards]');
      this.prev = this.querySelector('[data-pd-cs-prev]');
      this.next = this.querySelector('[data-pd-cs-next]');
      this.cardEls = this.cards ? this.cards.querySelectorAll('.pd-compare-series__card') : [];
      this.colCount = this.cardEls.length;
      this.rafId = null;

      var self = this;
      if (this.cards) {
        this._onScroll = function () {
          if (self.rafId) cancelAnimationFrame(self.rafId);
          self.rafId = requestAnimationFrame(function () { self._updateActiveCol(); });
        };
        this.cards.addEventListener('scroll', this._onScroll);
        window.addEventListener('resize', this._onScroll);

        // 桌面滚轮：横向 overflow 容器会把纵向滚轮 delta 转成横滚并吞掉，
        // 阻碍页面纵向滚动。纵向主导时阻止容器横滚、把滚动交还页面。
        // 仅在 carousel 模式（容器有横向溢出）介入；桌面 grid 模式不碰。
        this._onWheel = function (e) {
          if (self.cards.scrollWidth <= self.cards.clientWidth) return;
          if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
          e.preventDefault();
          var top = e.deltaY;
          if (e.deltaMode === 1) top *= 16;            // 行 → px
          else if (e.deltaMode === 2) top *= self.cards.clientHeight; // 页 → px
          window.scrollBy({ top: top });
        };
        this.cards.addEventListener('wheel', this._onWheel, { passive: false });

        this._updateActiveCol();
      }

      if (this.prev) this.prev.addEventListener('click', function () { self._step(-1); });
      if (this.next) this.next.addEventListener('click', function () { self._step(1); });

      this._initVariants();

      this._onDocClick = function (e) { self._handleDocClick(e); };
      document.addEventListener('click', this._onDocClick);

      this._initCtas();
      this._initExpand();
    }

    disconnectedCallback() {
      if (this.cards && this._onScroll) {
        this.cards.removeEventListener('scroll', this._onScroll);
      }
      if (this.cards && this._onWheel) {
        this.cards.removeEventListener('wheel', this._onWheel);
      }
      window.removeEventListener('resize', this._onScroll);
      document.removeEventListener('click', this._onDocClick);
    }

    _updateActiveCol() {
      if (!this.cards || this.colCount === 0) return;
      var midPoint = this.cards.scrollLeft + this.cards.clientWidth / 2;
      var nearest = 0;
      var nearestDist = Infinity;
      this.cardEls.forEach(function (card, idx) {
        var center = card.offsetLeft + card.clientWidth / 2;
        var dist = Math.abs(midPoint - center);
        if (dist < nearestDist) { nearestDist = dist; nearest = idx; }
      });
      this.setAttribute('data-active-col', String(nearest));
      this._syncNav(nearest);
    }

    _syncNav(idx) {
      // 首卡禁用 prev、末卡禁用 next（:disabled 由 pillar.css 上色）
      if (this.prev) {
        var atStart = idx <= 0;
        this.prev.disabled = atStart;
        this.prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (this.next) {
        var atEnd = idx >= this.colCount - 1;
        this.next.disabled = atEnd;
        this.next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }
    }

    _step(dir) {
      if (!this.cards || this.colCount === 0) return;
      var current = parseInt(this.getAttribute('data-active-col') || '0', 10);
      var targetIdx = Math.min(Math.max(current + dir, 0), this.colCount - 1);
      var target = this.cardEls[targetIdx];
      if (!target) return;
      // 滚到目标卡片左缘：不依赖 gap 硬编码，跨断点都精确
      this.cards.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    _closeAllVariants(except) {
      this.querySelectorAll('[data-pd-cs-variant]').forEach(function (v) {
        if (v === except) return;
        v.removeAttribute('data-open');
        var t = v.querySelector('[data-pd-cs-variant-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    _initVariants() {
      var self = this;
      this.querySelectorAll('[data-pd-cs-variant]').forEach(function (variant) {
        var toggle = variant.querySelector('[data-pd-cs-variant-toggle]');
        var list = variant.querySelector('[data-pd-cs-variant-list]');
        var labelEl = variant.querySelector('[data-pd-cs-variant-label]');
        var card = variant.closest('.pd-compare-series__card');
        var cta = card ? card.querySelector('[data-pd-cs-cta]') : null;
        var imageEl = card ? card.querySelector('[data-pd-cs-image]') : null;
        if (!toggle || !list) return;

        toggle.removeAttribute('disabled');
        toggle.removeAttribute('aria-disabled');
        // JS 接管：移除 SSR 写入的 hidden，让 CSS 通过 [data-open] 控制可见性 + 过渡动画
        list.removeAttribute('hidden');

        function openList() {
          self._closeAllVariants(variant);
          variant.setAttribute('data-open', 'true');
          toggle.setAttribute('aria-expanded', 'true');
        }
        function closeList() {
          variant.removeAttribute('data-open');
          toggle.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = variant.getAttribute('data-open') === 'true';
          if (open) {
            closeList();
          } else {
            openList();
          }
        });

        toggle.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            if (variant.getAttribute('data-open') !== 'true') openList();
            var opts = list.querySelectorAll('[data-pd-cs-variant-option]');
            var target = e.key === 'ArrowDown' ? opts[0] : opts[opts.length - 1];
            if (target) target.focus();
          }
        });

        list.addEventListener('keydown', function (e) {
          var opts = Array.prototype.slice.call(list.querySelectorAll('[data-pd-cs-variant-option]'));
          if (!opts.length) return;
          var idx = opts.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            opts[(idx + 1) % opts.length].focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            opts[(idx - 1 + opts.length) % opts.length].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            opts[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            opts[opts.length - 1].focus();
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeList();
            toggle.focus();
          }
        });

        var labelNameEl = labelEl ? labelEl.querySelector('[data-pd-cs-variant-name]') : null;
        var labelPriceEl = labelEl ? labelEl.querySelector('[data-pd-cs-variant-price]') : null;

        list.querySelectorAll('[data-pd-cs-variant-option]').forEach(function (opt) {
          opt.addEventListener('click', function () {
            var optNameEl = opt.querySelector('[data-pd-cs-option-name]');
            var optPriceEl = opt.querySelector('[data-pd-cs-option-price]');
            var newImage = opt.getAttribute('data-variant-image');
            var newVariantId = opt.getAttribute('data-variant-id');
            var newAvailable = opt.getAttribute('data-variant-available') === 'true';
            if (labelNameEl && optNameEl) labelNameEl.textContent = optNameEl.textContent;
            if (labelPriceEl && optPriceEl) labelPriceEl.innerHTML = optPriceEl.innerHTML;
            if (cta && newVariantId) cta.setAttribute('data-pd-cs-variant-id', newVariantId);
            if (cta) {
              cta.classList.toggle('pd-compare-series__cta--sold-out', !newAvailable);
              cta.toggleAttribute('disabled', !newAvailable);
              cta.setAttribute('aria-disabled', newAvailable ? 'false' : 'true');
              cta.setAttribute('data-pd-cs-variant-available', String(newAvailable));
              var ctaTextEl = cta.querySelector('.pd-compare-series__cta-text');
              if (ctaTextEl) {
                var availableText = cta.getAttribute('data-pd-cs-cta-text-available') || '';
                var soldOutText = cta.getAttribute('data-pd-cs-cta-text-sold-out') || '';
                ctaTextEl.textContent = newAvailable ? availableText : soldOutText;
              }
            }
            if (imageEl && newImage) {
              imageEl.src = newImage;
              var newSrcset = opt.getAttribute('data-variant-srcset') || '';
              if (newSrcset) {
                imageEl.setAttribute('srcset', newSrcset);
                imageEl.setAttribute('sizes', '(max-width: 1067px) 80vw, 33vw');
              } else {
                imageEl.removeAttribute('srcset');
                imageEl.removeAttribute('sizes');
              }
            }
            list.querySelectorAll('[data-pd-cs-variant-option]').forEach(function (o) {
              var isSel = o === opt;
              o.classList.toggle('is-selected', isSel);
              o.setAttribute('aria-selected', isSel ? 'true' : 'false');
            });
            variant.removeAttribute('data-open');
            toggle.setAttribute('aria-expanded', 'false');
          });
        });
      });
    }

    _handleDocClick(e) {
      this.querySelectorAll('[data-pd-cs-variant][data-open="true"]').forEach(function (v) {
        if (!v.contains(e.target)) {
          v.removeAttribute('data-open');
          var t = v.querySelector('[data-pd-cs-variant-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    }

    _initCtas() {
      this.querySelectorAll('[data-pd-cs-cta]').forEach(function (cta) {
        cta.addEventListener('click', function () {
          if (cta.classList.contains('loading')) return;
          if (cta.hasAttribute('disabled')) return;
          var variantId = cta.getAttribute('data-pd-cs-variant-id');
          if (!variantId) return;
          cta.classList.add('loading');
          cta.setAttribute('aria-busy', 'true');
          var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add';
          fetch(cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 })
          })
            .then(function (r) {
              return r.json().then(function (data) {
                if (!r.ok || (data && data.status)) {
                  var msg = (data && (data.description || data.message)) || 'cart_add_failed';
                  throw new Error(msg);
                }
                return data;
              });
            })
            .then(function (data) {
              // 单 item path：Shopify 返回单个 cart line（无 items wrapper）
              var addedItems = data && data.items ? data.items : (data ? [data] : []);
              pdCsPushAddToCartGA4(addedItems, 'pd_compare_series');
              window.location.href = '/cart';
            })
            .catch(function (err) {
              console.error('[pd-compare-series] add to cart failed:', err);
              var msg = err && err.message ? err.message : '';
              if (window.pillarShowCartError) window.pillarShowCartError(msg);
              cta.classList.remove('loading');
              cta.removeAttribute('aria-busy');
            });
        });
      });
    }

    _initExpand() {
      var expand = this.querySelector('[data-pd-cs-expand]');
      var features = this.querySelector('[data-pd-cs-features]');
      if (expand && features) {
        expand.addEventListener('click', function () {
          var expanded = expand.getAttribute('aria-expanded') === 'true';
          var next = !expanded;
          expand.setAttribute('aria-expanded', next ? 'true' : 'false');
          features.classList.toggle('is-expanded', next);
        });
      }
    }
  }

  window.customElements.define('pd-compare-series', PdCompareSeries);
})();
